<app-access-item [hideOverflow]="true">
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/tag-filled.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <span>Color Labels</span>
    <app-upgrade-badge scope="asset:color-labels" location="color-label-setting-item"></app-upgrade-badge>
  </app-access-item-header>
  <app-access-item-body>
    <app-gallery-settings-customize-button
      [location]="'color-labels-setting-item'"
      [show]="gallery().enabled_feedback_options.includes('color_label')"
      (onClick)="customize.emit()"
    ></app-gallery-settings-customize-button>
  </app-access-item-body>
  <app-access-item-cta>
    <app-switch [smallish]="true">
      <input
        type="checkbox"
        id="color-labels"
        [(ngModel)]="colorLabels"
        (ngModelChange)="updateColorLabel()"
        [disabled]="!('asset:color-labels' | billingScope)"
      />
      <label for="color-labels" data-test-id="color-labels"></label>
    </app-switch>
  </app-access-item-cta>
</app-access-item>
